<template>
	<div>
		<b-container>
			<b-breadcrumb :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
			<b-row style="margin: 10px 0px 10px 0px; padding: 0px;">
				<b-col cols="3" style="padding-left:0px;">
					<b-button variant="primary" block class="title" @click="newComputingMetrics"> {{$lang.computingMetrics.new}}</b-button>
				</b-col>
				<!-- <b-col cols="9" style="padding-right: 0px;" >
					<b-input-group >
						<b-input :placeholder="$lang.common.search"/>
						<b-input-group-append>
							<b-button variant="outline-primary">{{ $lang.common.search }}</b-button>
						</b-input-group-append>
					</b-input-group>
				</b-col> -->
			</b-row>
			<b-table striped hover outlined :items="$store.getters.computingMetrics" :fields="fields" @row-clicked="editComputingMetric" style="cursor:pointer">
				<template v-slot:cell(index)="data">
					{{ data.index + 1 }}
				</template>
				<template v-slot:cell(orderNumber)="data">
					{{ data.documentName }}
				</template>
				<template v-slot:cell(status)="data">
					{{ data.item.status}}
				</template>
			</b-table>
			<b-button variant="primary" class="title" block value="Save" v-on:click="loadMore" v-if="$store.state.computingMetrics.computingMetricsPagination.showLoadMore == true">{{$lang.buttons.loadMore}}</b-button>
		</b-container>
	</div>
</template>

<script>

export default {
	data() {
		return {
			fields: [
				{key: 'index', label: '#'},
				{key: 'documentName', label: 'Nombre del documento'},
				{key: 'status', label: 'Estado'}
			],
			breadcrumb: [{'text': this.$lang.modules.computingMetrics,'href': '#'},{'text': this.$lang.computingMetrics.list,'href': '#'}],
		}
	},

	methods: {
		newComputingMetrics() {
			this.$router.push({ name: 'ComputingMetricsNew' })
		},
		editComputingMetric(computingMetric) {
			this.$router.push({ name: 'ComputingMetricsEdit', params: { computingMetricId: computingMetric.id } })
		},
		loadMore() {
			let currentPagination = this.$store.getters.computingMetricsPagination;
			this.$store.dispatch('updateComputingMetricsPagination', {page: currentPagination.page++, ...currentPagination});
			this.$store.dispatch('fetchComputingMetrics');
		}
	},
	created() {
		this.$store.commit('setComputingMetricsPagination', { page: 1, pageSize: 10, lastVisible: null, showLoadMore: true });
        this.$store.commit('setComputingMetrics', []);
		this.$Progress.start()
		this.$store.dispatch('fetchComputingMetrics')
		this.$Progress.finish();
	}
}
</script>

<style>

</style>